import {useState} from 'react';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import './Register.css';
import {getBaseUrl, getRememberPreference, login} from "./api";
import LanguageSwitcher from './LanguageSwitcher';

function Register({onRegister}) {
  const {t} = useTranslation();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [rememberMe] = useState(getRememberPreference);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError(t('auth.register.passwordsMismatch'));
      return;
    }

    setIsLoading(true);

    try {
      const response = await fetch(`${getBaseUrl()}/api/v0/auth/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({username, password}),
      });

      if (response.ok) {
        // Log the new user straight in to obtain JWT tokens. If the account still
        // needs to be enabled, login fails and we send them to the login page.
        try {
          await login(username, password, rememberMe);
          onRegister();
        } catch (loginErr) {
          setError(t('auth.register.accountCreated'));
        }
      } else {
        const errorData = await response.json();
        setError(errorData.message || t('auth.register.failed'));
      }
    } catch (err) {
      setError(t('common.networkError'));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="register-container">
      <div className="register-box">
        <div className="auth-language-switcher">
          <LanguageSwitcher disabled={isLoading} />
        </div>
        <img
          src={`${process.env.PUBLIC_URL}/logo512.png`}
          alt="AutoLang logo"
          className="auth-logo"
        />
        <h1>{t('common.appName')}</h1>
        <h2>{t('auth.register.title')}</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">{t('auth.login.username')}</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              disabled={isLoading}
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">{t('auth.login.password')}</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={isLoading}
            />
          </div>
          <div className="form-group">
            <label htmlFor="confirmPassword">{t('auth.register.confirmPassword')}</label>
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              disabled={isLoading}
            />
          </div>
          {error && <div className="error-message">{error}</div>}
          <button type="submit" disabled={isLoading}>
            {isLoading ? t('auth.register.submitting') : t('auth.register.submit')}
          </button>
        </form>
        <div className="switch-auth">
          {t('auth.register.haveAccount')}{' '}
          <Link to="/login" className="link-button">
            {t('auth.register.loginLink')}
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Register;
